import React, { useState, useEffect } from "react";
// @material-ui/icons
import { makeStyles } from "@material-ui/core/styles";
import { FormControl, Select, MenuItem, InputLabel } from "@material-ui/core";
import useOrderStatusShipment from "hooks/useOrderStatusShipment";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
const useStyles = makeStyles(styles);

export default function OrderStatusShipment(props) {
    const { onChange = () => {} } = props;
    const classes = useStyles();
    const [statusId, setStatusId] = useState(props.statusId || 0);
    const orderStatus = useOrderStatusShipment();

    useEffect(() => {
        if (props.statusId && statusId !== props.statusId) {
            setStatusId(props.statusId);
        }
    }, [props.statusId]);

    return (
        <FormControl className={classes.formControl} fullWidth>
            <Select
                value={statusId}
                onChange={(e) => {
                    setStatusId(e.target.value);
                    onChange(e.target.value);
                }}
            >
                <MenuItem value={0}>Select status</MenuItem>
                {orderStatus.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        {item.status}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
